/**
 * Khmer for every English text of the console (the English text is the key). A missing entry shows the English text — add the Khmer here
 * with every new label.
 */
export const KM: Record<string, string> = {
  // menu and frame
  'Lottery Platform': 'វេទិកាឆ្នោត',
  'Command Center': 'មជ្ឈមណ្ឌលបញ្ជា',
  Dashboard: 'ផ្ទាំងទូទៅ',
  Clients: 'អតិថិជន',
  Products: 'ប្រភេទឆ្នោត',
  Packages: 'កញ្ចប់សេវា',
  Templates: 'គំរូ',
  Domains: 'ដែន',
  Releases: 'ការចេញកំណែ',
  'System Health': 'សុខភាពប្រព័ន្ធ',
  Audit: 'កំណត់ត្រាសកម្មភាព',
  'Arrives in phase': 'មកដល់នៅដំណាក់កាលទី',
  Menu: 'ម៉ឺនុយ',
  Language: 'ភាសា',
  'Sign out': 'ចាកចេញ',
  // sign in and password
  Username: 'ឈ្មោះអ្នកប្រើប្រាស់',
  Password: 'លេខសម្ងាត់',
  'Sign in': 'ចូលប្រើប្រាស់',
  'Signing in…': 'កំពុងចូល…',
  'Show password': 'បង្ហាញលេខសម្ងាត់',
  'Hide password': 'លាក់លេខសម្ងាត់',
  'Change password': 'ប្តូរលេខសម្ងាត់',
  'Current password': 'លេខសម្ងាត់បច្ចុប្បន្ន',
  'New password': 'លេខសម្ងាត់ថ្មី',
  'New password again': 'លេខសម្ងាត់ថ្មីម្តងទៀត',
  'At least 10 characters, with a letter and a digit': 'យ៉ាងតិច ១០ តួ មានអក្សរ និងលេខ',
  'The two new passwords are not the same': 'លេខសម្ងាត់ថ្មីទាំងពីរមិនដូចគ្នា',
  'The current password is not right': 'លេខសម្ងាត់បច្ចុប្បន្នមិនត្រឹមត្រូវ',
  'Please choose your own password before you continue.': 'សូមជ្រើសលេខសម្ងាត់ផ្ទាល់ខ្លួន មុននឹងបន្ត។',
  'A new password signs you out on every other device.': 'លេខសម្ងាត់ថ្មីនឹងចាកចេញពីឧបករណ៍ផ្សេងទៀតទាំងអស់។',
  'Password changed.': 'បានប្តូរលេខសម្ងាត់។',
  // dashboard
  Welcome: 'សូមស្វាគមន៍',
  'Your three jobs: bring a client on, support them, push updates.': 'ការងារបីរបស់អ្នក៖ ទទួលអតិថិជនថ្មី ជួយគាំទ្រពួកគេ និងបញ្ចេញការធ្វើបច្ចុប្បន្នភាព។',
  'Clients that need a look': 'អតិថិជនដែលត្រូវពិនិត្យ',
  'Every client is fine.': 'អតិថិជនទាំងអស់មិនមានបញ្ហាទេ។',
  // clients
  'Every client on one screen. Open a client to look closer.': 'អតិថិជនទាំងអស់នៅលើអេក្រង់តែមួយ។ បើកអតិថិជនម្នាក់ ដើម្បីមើលលម្អិត។',
  Company: 'ក្រុមហ៊ុន',
  Package: 'កញ្ចប់សេវា',
  State: 'ស្ថានភាព',
  Users: 'អ្នកប្រើប្រាស់',
  Agents: 'ភ្នាក់ងារ',
  'Last activity': 'សកម្មភាពចុងក្រោយ',
  Problems: 'បញ្ហា',
  problem: 'បញ្ហា',
  problems: 'បញ្ហា',
  Testing: 'កំពុងសាកល្បង',
  Live: 'កំពុងដំណើរការ',
  Suspended: 'ផ្អាក',
  Closed: 'បានបិទ',
  'With problems': 'មានបញ្ហា',
  'All states': 'គ្រប់ស្ថានភាព',
  'Code or name': 'កូដ ឬឈ្មោះ',
  'Problems only': 'តែអ្នកមានបញ្ហា',
  None: 'គ្មាន',
  'No client matches': 'គ្មានអតិថិជនត្រូវនឹងការស្វែងរក',
  'No client yet': 'មិនទាន់មានអតិថិជន',
  'Clients are created in phase 7.': 'អតិថិជនត្រូវបង្កើតនៅដំណាក់កាលទី ៧។',
  'Packages arrive in phase 5': 'កញ្ចប់សេវាមកដល់នៅដំណាក់កាលទី ៥',
  Never: 'មិនធ្លាប់',
  Today: 'ថ្ងៃនេះ',
  Yesterday: 'ម្សិលមិញ',
  'days ago': 'ថ្ងៃមុន',
  // one client
  'All clients': 'អតិថិជនទាំងអស់',
  'Client not found': 'រកមិនឃើញអតិថិជន',
  Health: 'សុខភាព',
  'Nothing is wrong with this client.': 'អតិថិជននេះគ្មានបញ្ហាអ្វីទេ។',
  Error: 'កំហុស',
  Warning: 'ការព្រមាន',
  Details: 'ព័ត៌មានលម្អិត',
  'Address name': 'ឈ្មោះអាសយដ្ឋាន',
  'Time zone': 'តំបន់ម៉ោង',
  Currency: 'រូបិយប័ណ្ណ',
  Contact: 'ទំនាក់ទំនង',
  'Client since': 'ជាអតិថិជនតាំងពី',
  Activity: 'សកម្មភាព',
  'Nothing yet.': 'មិនទាន់មានអ្វីទេ។',
  System: 'ប្រព័ន្ធ',
  // audit
  'Every change and every sign-in, newest first. Nothing here can be changed or removed.': 'រាល់ការផ្លាស់ប្តូរ និងការចូលប្រើប្រាស់ ថ្មីបំផុតនៅខាងលើ។ គ្មានអ្វីនៅទីនេះអាចកែ ឬលុបបានទេ។',
  When: 'ពេលណា',
  What: 'អ្វី',
  Who: 'នរណា',
  Client: 'អតិថិជន',
  On: 'លើ',
  Address: 'អាសយដ្ឋាន IP',
  Before: 'មុន',
  After: 'ក្រោយ',
  'Show older': 'បង្ហាញចាស់ជាងនេះ',
  // health
  'Checked every 15 seconds.': 'ពិនិត្យរៀងរាល់ ១៥ វិនាទី។',
  Platform: 'វេទិកា',
  Database: 'មូលដ្ឋានទិន្នន័យ',
  Working: 'ដំណើរការ',
  Problem: 'មានបញ្ហា',
  'Checked at': 'ពិនិត្យនៅ',
  'Coming with later phases': 'នឹងមកជាមួយដំណាក់កាលក្រោយ',
  'Background jobs, backups and result sources appear here when the phases that add them are built.': 'ការងារផ្ទៃខាងក្រោយ ការបម្រុងទុក និងប្រភពលទ្ធផល នឹងបង្ហាញនៅទីនេះ នៅពេលដំណាក់កាលដែលបន្ថែមវាត្រូវបានសាងសង់។',
  // ---- Phase 2: products (terms as the earlier console used them: ប៉ុស្តិ៍, ល្បែង, កំណែ, ម៉ោងចេញលទ្ធផល)
  Product: 'ប្រភេទឆ្នោត',
  'All products': 'ប្រភេទឆ្នោតទាំងអស់',
  'The lottery products of the platform. A client installs a product at a version and stays on it until it is moved.': 'ប្រភេទឆ្នោតរបស់វេទិកា។ អតិថិជនដំឡើងប្រភេទឆ្នោតតាមកំណែមួយ ហើយនៅលើកំណែនោះរហូតដល់ត្រូវបានផ្លាស់ប្តូរ។',
  'No product yet': 'មិនទាន់មានប្រភេទឆ្នោត',
  Games: 'ល្បែង',
  Game: 'ល្បែង',
  'Draws a day': 'ចំនួនចេញលទ្ធផលក្នុងមួយថ្ងៃ',
  Version: 'កំណែ',
  Versions: 'កំណែ',
  Draft: 'សេចក្តីព្រាង',
  Published: 'បានផ្សាយ',
  Publish: 'ផ្សាយ',
  Active: 'សកម្ម',
  Inactive: 'អសកម្ម',
  'Make active': 'ធ្វើឱ្យសកម្ម',
  'Make inactive': 'ធ្វើឱ្យអសកម្ម',
  'Edit draft': 'កែសេចក្តីព្រាង',
  'New version': 'កំណែថ្មី',
  Draws: 'ការចេញលទ្ធផល',
  Draw: 'ការចេញលទ្ធផល',
  'Next 14 days': '១៤ ថ្ងៃខាងមុខ',
  Exceptions: 'ករណីលើកលែង',
  'Back to the published version': 'ត្រឡប់ទៅកំណែដែលបានផ្សាយ',
  'No published version yet.': 'មិនទាន់មានកំណែដែលបានផ្សាយ។',
  Note: 'កំណត់ចំណាំ',
  Edit: 'កែប្រែ',
  View: 'មើល',
  'A published version never changes. A client stays on its version until it is moved on its page.': 'កំណែដែលបានផ្សាយមិនផ្លាស់ប្តូរឡើយ។ អតិថិជននៅលើកំណែរបស់ខ្លួន រហូតដល់ត្រូវបានផ្លាស់ប្តូរនៅលើទំព័ររបស់វា។',
  'A draw cancelled, moved to another day, or an extra draw — for holidays. It applies to every client with the product, whatever its version.': 'ការចេញលទ្ធផលដែលត្រូវលុបចោល ផ្លាស់ទៅថ្ងៃផ្សេង ឬចេញបន្ថែម — សម្រាប់ថ្ងៃឈប់សម្រាក។ វាអនុវត្តចំពោះអតិថិជនទាំងអស់ដែលមានប្រភេទឆ្នោតនេះ មិនថាកំណែណាក៏ដោយ។',
  Cancelled: 'បានលុបចោល',
  Moved: 'បានផ្លាស់',
  Extra: 'បន្ថែម',
  Remove: 'ដកចេញ',
  Removed: 'បានដកចេញ',
  Date: 'កាលបរិច្ឆេទ',
  'New date': 'កាលបរិច្ឆេទថ្មី',
  Time: 'ម៉ោង',
  'New time (optional)': 'ម៉ោងថ្មី (មិនចាំបាច់)',
  Add: 'បន្ថែម',
  Posts: 'ប៉ុស្តិ៍',
  Digits: 'ខ្ទង់',
  Rule: 'ច្បាប់',
  'Betting closes': 'បិទការចាក់',
  'min before the draw': 'នាទីមុនចេញលទ្ធផល',
  'default — to confirm': 'លំនាំដើម — ត្រូវបញ្ជាក់',
  'default close — to confirm': 'ម៉ោងបិទលំនាំដើម — ត្រូវបញ្ជាក់',
  'Every day': 'រៀងរាល់ថ្ងៃ',
  'Dates of each month': 'ថ្ងៃទីនៃខែនីមួយៗ',
  Sun: 'អាទិត្យ',
  Mon: 'ចន្ទ',
  Tue: 'អង្គារ',
  Wed: 'ពុធ',
  Thu: 'ព្រហស្បតិ៍',
  Fri: 'សុក្រ',
  Sat: 'សៅរ៍',
  'No draw in these days.': 'គ្មានការចេញលទ្ធផលក្នុងថ្ងៃទាំងនេះទេ។',
  local: 'ម៉ោងក្នុងស្រុក',
  closes: 'បិទ',
  'Times are Cambodia time.': 'ម៉ោងទាំងអស់ជាម៉ោងកម្ពុជា។',
  // draft editor
  Saved: 'បានរក្សាទុក',
  'Save draft': 'រក្សាទុកសេចក្តីព្រាង',
  'Nothing here is in force until it is published. A client moves to the new version only from its own page.': 'គ្មានអ្វីនៅទីនេះចូលជាធរមានទេ រហូតដល់វាត្រូវបានផ្សាយ។ អតិថិជនផ្លាស់ទៅកំណែថ្មី តែពីទំព័ររបស់ខ្លួនប៉ុណ្ណោះ។',
  'This version is published and never changes. Make a new version to change the product.': 'កំណែនេះបានផ្សាយ ហើយមិនផ្លាស់ប្តូរឡើយ។ សូមបង្កើតកំណែថ្មី ដើម្បីផ្លាស់ប្តូរប្រភេទឆ្នោត។',
  Name: 'ឈ្មោះ',
  'Name (Khmer)': 'ឈ្មោះ (ខ្មែរ)',
  'Draw days': 'ថ្ងៃចេញលទ្ធផល',
  'Days of the week': 'ថ្ងៃក្នុងសប្តាហ៍',
  'Default close (minutes before the draw)': 'ម៉ោងបិទលំនាំដើម (នាទីមុនចេញលទ្ធផល)',
  'Dates (e.g. 1 16)': 'ថ្ងៃទី (ឧ. 1 16)',
  'Draw time': 'ម៉ោងចេញលទ្ធផល',
  'Posts (empty = all)': 'ប៉ុស្តិ៍ (ទទេ = ទាំងអស់)',
  'Remove draw': 'ដកការចេញលទ្ធផលចេញ',
  'Same every day': 'ដូចគ្នារៀងរាល់ថ្ងៃ',
  'Per weekday': 'តាមថ្ងៃនីមួយៗ',
  'Close time for posts': 'ម៉ោងបិទសម្រាប់ប៉ុស្តិ៍',
  'Add a draw': 'បន្ថែមការចេញលទ្ធផល',
  'Next 7 days with this draft': '៧ ថ្ងៃខាងមុខ តាមសេចក្តីព្រាងនេះ',
  Cancel: 'បោះបង់',
  'A published version never changes. Clients stay on their version until you move them.': 'កំណែដែលបានផ្សាយមិនផ្លាស់ប្តូរឡើយ។ អតិថិជននៅលើកំណែរបស់ខ្លួន រហូតដល់អ្នកផ្លាស់ពួកគេ។',
  'Type the product code to confirm': 'វាយកូដប្រភេទឆ្នោត ដើម្បីបញ្ជាក់',
  // a client's products
  'No product installed yet.': 'មិនទាន់បានដំឡើងប្រភេទឆ្នោតទេ។',
  Newer: 'ថ្មីជាង',
  'Move to': 'ផ្លាស់ទៅ',
  'Product to install': 'ប្រភេទឆ្នោតដែលត្រូវដំឡើង',
  Install: 'ដំឡើង',
  // ---- Phase 3: results
  Results: 'លទ្ធផល',
  Result: 'លទ្ធផល',
  'Enter each draw’s result, check it, publish it. Only a published result counts.': 'បញ្ចូលលទ្ធផលនៃការចេញនីមួយៗ ពិនិត្យ រួចផ្សាយ។ មានតែលទ្ធផលដែលបានផ្សាយប៉ុណ្ណោះដែលមានសុពលភាព។',
  'Previous day': 'ថ្ងៃមុន',
  'Next day': 'ថ្ងៃបន្ទាប់',
  'No draw on this day.': 'គ្មានការចេញលទ្ធផលនៅថ្ងៃនេះទេ។',
  published: 'បានផ្សាយ',
  'No result': 'គ្មានលទ្ធផល',
  Pattern: 'គំរូលទ្ធផល',
  'Every post typed by hand': 'ប៉ុស្តិ៍ទាំងអស់វាយបញ្ចូលដោយដៃ',
  'Posts typed by hand': 'ប៉ុស្តិ៍ដែលវាយបញ្ចូលដោយដៃ',
  Post: 'ប៉ុស្តិ៍',
  Amend: 'កែតម្រូវ',
  Amended: 'បានកែតម្រូវ',
  Entered: 'បានបញ្ចូល',
  Check: 'ពិនិត្យ',
  'Reason for the amendment': 'មូលហេតុនៃការកែតម្រូវ',
  'Save the amendment': 'រក្សាទុកការកែតម្រូវ',
  'Result of what is typed (not saved)': 'លទ្ធផលពីអ្វីដែលបានវាយ (មិនទាន់រក្សាទុក)',
  History: 'ប្រវត្តិ',
  'This is the result that counts. Check it one more time:': 'នេះជាលទ្ធផលដែលមានសុពលភាព។ សូមពិនិត្យម្តងទៀត៖',
  'Paste from a result page': 'បិទភ្ជាប់ពីទំព័រលទ្ធផល',
  'Paste the text of the official result page here': 'បិទភ្ជាប់អត្ថបទនៃទំព័រលទ្ធផលផ្លូវការនៅទីនេះ',
  'Read into the form': 'អានចូលក្នុងទម្រង់',
  'Filled from a paste — check it': 'បានបំពេញពីការបិទភ្ជាប់ — សូមពិនិត្យ',
  // patterns
  'Result patterns': 'គំរូលទ្ធផល',
  'How a draw’s result sheet becomes the result of each post. A product’s game names its pattern; a post no pattern produces is typed by hand as its 2D and 3D number.': 'របៀបដែលសន្លឹកលទ្ធផលនៃការចេញ ក្លាយជាលទ្ធផលនៃប៉ុស្តិ៍នីមួយៗ។ ល្បែងនៃប្រភេទឆ្នោតកំណត់គំរូរបស់វា ប៉ុស្តិ៍ដែលគ្មានគំរូផលិត ត្រូវវាយបញ្ចូលដោយដៃជាលេខ 2D និង 3D។',
  'In use': 'កំពុងប្រើ',
  'Not used yet': 'មិនទាន់ប្រើ',
  'Sheets it reads': 'សន្លឹកដែលវាអាន',
  'Chosen by weekday': 'ជ្រើសតាមថ្ងៃក្នុងសប្តាហ៍',
  'Posts it pays': 'ប៉ុស្តិ៍ដែលវាបង់',
  'Used by': 'ប្រើដោយ',
  // ---- Phase 4: tickets (bet modes as the engine names them: ចាក់ធម្មតា, ចាក់គុណ, អូស…)
  Tickets: 'សំបុត្រ',
  Ticket: 'សំបុត្រ',
  'Test ticket': 'សំបុត្រសាកល្បង',
  'Test sales prove a product end to end before a client goes live: the slip is priced by the betting engine and settled from the published result.': 'ការលក់សាកល្បងបញ្ជាក់ប្រភេទឆ្នោតពីដើមដល់ចប់ មុនពេលអតិថិជនដំណើរការពិត៖ សន្លឹកចាក់ត្រូវគិតតម្លៃដោយម៉ាស៊ីនចាក់ ហើយទូទាត់ពីលទ្ធផលដែលបានផ្សាយ។',
  'No ticket yet.': 'មិនទាន់មានសំបុត្រទេ។',
  Total: 'សរុប',
  Won: 'ឈ្នះ',
  Lost: 'ចាញ់',
  Open: 'រង់ចាំលទ្ធផល',
  Sold: 'បានលក់',
  'Install a product for this client first.': 'សូមដំឡើងប្រភេទឆ្នោតសម្រាប់អតិថិជននេះជាមុនសិន។',
  'No open draw in the next days.': 'គ្មានការចេញលទ្ធផលដែលនៅបើកក្នុងថ្ងៃខាងមុខទេ។',
  Number: 'លេខ',
  How: 'របៀបចាក់',
  To: 'ដល់',
  'Amount per number': 'ទឹកប្រាក់ក្នុងមួយលេខ',
  'Add a line': 'បន្ថែមបន្ទាត់',
  'Price it': 'គិតតម្លៃ',
  Sell: 'លក់',
  Close: 'បិទ',
  'Reason to cancel': 'មូលហេតុលុបចោល',
  'Cancel ticket': 'លុបចោលសំបុត្រ',
  Single: 'ចាក់ធម្មតា',
  'Multiply (all arrangements)': 'ចាក់គុណ (គ្រប់ការរៀប)',
  'Roll from … to …': 'អូសធម្មតា (ពី … ដល់ …)',
  'Roll odd': 'អូសសេស',
  'Roll even': 'អូសគូ',
  'Roll the head digit': 'អូសក្បាល',
  'Roll the middle digit': 'អូសកណ្ដាល',
  'Roll the tail digit': 'អូសកន្ទុយ',
  'Roll special': 'អូសពិសេស',
  'Roll W': 'អូស W',
  'Roll W and multiply': 'អូស W + គុណ',
  // betting rules
  Pays: 'បង់',
  'Costs more': 'តម្លៃច្រើនជាង',
  'Not sold': 'មិនលក់',
  step: 'ជំហាន',
  Step: 'ជំហាន',
  'Pays 2D ×': 'បង់ 2D ×',
  'Pays 3D ×': 'បង់ 3D ×',
  'Least per number': 'តិចបំផុតក្នុងមួយលេខ',
  'Most per number': 'ច្រើនបំផុតក្នុងមួយលេខ',
  // packages (Phase 5)
  'All packages': 'កញ្ចប់ទាំងអស់',
  'Android app (APK)': 'កម្មវិធី Android (APK)',
  Archive: 'ដាក់ក្នុងបណ្ណសារ',
  Archived: 'ក្នុងបណ្ណសារ',
  Change: 'ប្តូរ',
  'Change package': 'ប្តូរកញ្ចប់',
  'Clients on this package': 'អតិថិជនលើកញ្ចប់នេះ',
  Code: 'កូដ',
  'Console users': 'អ្នកប្រើផ្ទាំងគ្រប់គ្រង',
  'Create draft': 'បង្កើតសេចក្តីព្រាង',
  'Data entry team': 'ក្រុមបញ្ចូលទិន្នន័យ',
  Description: 'ការពិពណ៌នា',
  'Every product, including new ones': 'គ្រប់ប្រភេទឆ្នោត រួមទាំងប្រភេទថ្មីៗ',
  Features: 'មុខងារ',
  Give: 'ផ្តល់',
  'Give a package': 'ផ្តល់កញ្ចប់',
  Limits: 'កំណត់',
  'More than the package allows': 'លើសពីកញ្ចប់អនុញ្ញាត',
  'Move all to': 'ផ្លាស់ទាំងអស់ទៅ',
  'Name (English)': 'ឈ្មោះ (អង់គ្លេស)',
  'New package': 'កញ្ចប់ថ្មី',
  'No client is on this package.': 'គ្មានអតិថិជនលើកញ្ចប់នេះទេ។',
  'No limit': 'គ្មានកំណត់',
  'No package': 'គ្មានកញ្ចប់',
  'No package yet': 'មិនទាន់មានកញ្ចប់',
  'No package — the client may not have or sell anything': 'គ្មានកញ្ចប់ — អតិថិជនមិនអាចមាន ឬលក់អ្វីបានទេ',
  'Nothing here is in force until it is published. Clients move to the new version from the package page.': 'គ្មានអ្វីនៅទីនេះមានប្រសិទ្ធភាពទេ រហូតដល់ផ្សាយ។ អតិថិជនផ្លាស់ទៅកំណែថ្មីពីទំព័រកញ្ចប់។',
  'Only these': 'តែទាំងនេះ',
  'Open the package': 'បើកកញ្ចប់',
  'Own domain name': 'ឈ្មោះដែនផ្ទាល់ខ្លួន',
  'Own game rules': 'ច្បាប់ល្បែងផ្ទាល់ខ្លួន',
  'Own report design': 'ការរចនារបាយការណ៍ផ្ទាល់ខ្លួន',
  'Own ticket design': 'ការរចនាសំបុត្រផ្ទាល់ខ្លួន',
  Save: 'រក្សាទុក',
  'Start as a copy of': 'ចាប់ផ្តើមជាច្បាប់ចម្លងនៃ',
  'This version is published and never changes. Make a new version to change the package.': 'កំណែនេះបានផ្សាយហើយ មិនផ្លាស់ប្តូរទេ។ សូមបង្កើតកំណែថ្មី ដើម្បីប្តូរកញ្ចប់។',
  'Type the package code to confirm': 'វាយកូដកញ្ចប់ ដើម្បីបញ្ជាក់',
  'Used of the limits': 'បានប្រើពីកំណត់',
  'Web / PWA agent app': 'កម្មវិធីភ្នាក់ងារ Web / PWA',
  'What a client may have and use. The server checks it on every sale and install; a client stays on its package version until it is moved.': 'អ្វីដែលអតិថិជនអាចមាន និងប្រើ។ ម៉ាស៊ីនមេពិនិត្យរាល់ការលក់ និងការដំឡើង។ អតិថិជននៅលើកំណែកញ្ចប់របស់ខ្លួន រហូតដល់ត្រូវបានផ្លាស់។',
  'What changed in this version': 'អ្វីដែលបានប្តូរក្នុងកំណែនេះ',
  'What it gives': 'អ្វីដែលវាផ្តល់',
  'up to': 'រហូតដល់',
  // product names and draft delete
  'Delete': 'លុប',
  'Delete draft': 'លុបសេចក្តីព្រាង',
  'Name for this client': 'ឈ្មោះសម្រាប់អតិថិជននេះ',
  'Own name': 'ឈ្មោះផ្ទាល់ខ្លួន',
  'Own name (English) — optional': 'ឈ្មោះផ្ទាល់ខ្លួន (អង់គ្លេស) — មិនចាំបាច់',
  'Own name (Khmer) — optional': 'ឈ្មោះផ្ទាល់ខ្លួន (ខ្មែរ) — មិនចាំបាច់',
  'Platform name': 'ឈ្មោះវេទិកា',
  'Rename': 'ប្តូរឈ្មោះ',
  'The code stays. Clients with their own name for this product keep it.': 'កូដនៅដដែល។ អតិថិជនដែលមានឈ្មោះផ្ទាល់ខ្លួនសម្រាប់ផលិតផលនេះ រក្សាឈ្មោះរបស់ខ្លួន។',
  'The draft and its changes are thrown away. Published versions and the clients on them are not touched.': 'សេចក្តីព្រាង និងការកែប្រែរបស់វានឹងត្រូវបោះចោល។ កំណែដែលបានផ្សាយ និងអតិថិជនលើវាមិនប៉ះពាល់ទេ។',
  'Use the platform name': 'ប្រើឈ្មោះវេទិកា',
  // templates and settings (Phase 6)
  "A line printed under every ticket": "មួយបន្ទាត់បោះពុម្ពនៅក្រោមសំបុត្រនីមួយៗ",
  "A published version never changes. Companies stay on their version until you move them.": "កំណែដែលបានផ្សាយមិនផ្លាស់ប្តូរទេ។ ក្រុមហ៊ុននៅលើកំណែរបស់ខ្លួន រហូតដល់អ្នកផ្លាស់វា។",
  "All templates": "គំរូទាំងអស់",
  "Clients on this template": "អតិថិជនលើគំរូនេះ",
  "Configuration": "ការកំណត់រចនាសម្ព័ន្ធ",
  "Current value": "តម្លៃបច្ចុប្បន្ន",
  "Empty": "ទទេ",
  "For": "សម្រាប់",
  "Give a template": "ផ្តល់គំរូ",
  "Inherited": "ទទួលពីខាងលើ",
  "Most per number (riel)": "ច្រើនបំផុតក្នុងមួយលេខ (រៀល)",
  "New template": "គំរូថ្មី",
  "No client is on this template.": "គ្មានអតិថិជនលើគំរូនេះទេ។",
  "No template": "គ្មានគំរូ",
  "No template yet": "មិនទាន់មានគំរូ",
  "Not in the package": "មិនមានក្នុងកញ្ចប់",
  "Nothing here is in force until it is published. Companies move to the new version from the template page.": "គ្មានអ្វីនៅទីនេះមានប្រសិទ្ធភាពទេ រហូតដល់ផ្សាយ។ ក្រុមហ៊ុនផ្លាស់ទៅកំណែថ្មីពីទំព័រគំរូ។",
  "Nothing set here — every value comes from the layer below.": "មិនបានកំណត់អ្វីនៅទីនេះទេ — តម្លៃទាំងអស់មកពីស្រទាប់ខាងក្រោម។",
  "Payout 2D (×)": "សងលុយ 2D (×)",
  "Payout 3D (×)": "សងលុយ 3D (×)",
  "Platform default": "លំនាំដើមវេទិកា",
  "Reset to inherited": "ត្រឡប់ទៅតម្លៃទទួលពីខាងលើ",
  "Sales close this many minutes before the product’s close time of each post": "ការលក់បិទមុនម៉ោងបិទរបស់ប្រភេទឆ្នោតនៃប៉ុស្តិ៍នីមួយៗ ប៉ុន្មាននាទីនេះ",
  "Set": "កំណត់",
  "Setting": "ការកំណត់",
  "Settings": "ការកំណត់",
  "Sold with the client’s own payout": "លក់ដោយអត្រាសងផ្ទាល់ខ្លួនរបស់អតិថិជន",
  "Source": "ប្រភព",
  "Stop sales earlier (minutes)": "បិទការលក់មុន (នាទី)",
  "Template": "គំរូ",
  "The client’s package does not include this": "កញ្ចប់របស់អតិថិជនមិនរួមបញ្ចូលមុខងារនេះទេ",
  "The company’s own value": "តម្លៃផ្ទាល់ខ្លួនរបស់ក្រុមហ៊ុន",
  "The largest amount on one number; empty = the product’s own rule": "ទឹកប្រាក់ធំបំផុតលើលេខមួយ; ទទេ = ច្បាប់ផ្ទាល់របស់ប្រភេទឆ្នោត",
  "The package’s values: above the platform default, below a template and the company’s own values.": "តម្លៃរបស់កញ្ចប់៖ នៅលើលំនាំដើមវេទិកា នៅក្រោមគំរូ និងតម្លៃផ្ទាល់ខ្លួនរបស់ក្រុមហ៊ុន។",
  "The product’s own rule": "ច្បាប់ផ្ទាល់របស់ប្រភេទឆ្នោត",
  "This version is published and never changes. Make a new version to change the template.": "កំណែនេះបានផ្សាយហើយ មិនផ្លាស់ប្តូរទេ។ សូមបង្កើតកំណែថ្មី ដើម្បីប្តូរគំរូ។",
  "Ticket footer": "បាតសំបុត្រ",
  "Type a value": "សូមវាយតម្លៃ",
  "Type the template code to confirm": "វាយកូដគំរូ ដើម្បីបញ្ជាក់",
  "Value": "តម្លៃ",
  "What a new company starts with: its products and its settings. A company stays on its template version until it is moved.": "អ្វីដែលក្រុមហ៊ុនថ្មីចាប់ផ្តើមជាមួយ៖ ប្រភេទឆ្នោត និងការកំណត់។ ក្រុមហ៊ុននៅលើកំណែគំរូរបស់ខ្លួន រហូតដល់ត្រូវបានផ្លាស់។",
  "What one winning 2D number pays, × the amount; empty = the product’s own rule": "អ្វីដែលលេខ 2D ឈ្នះមួយសង × ទឹកប្រាក់; ទទេ = ច្បាប់ផ្ទាល់របស់ប្រភេទឆ្នោត",
  "What one winning 3D number pays, × the amount; empty = the product’s own rule": "អ្វីដែលលេខ 3D ឈ្នះមួយសង × ទឹកប្រាក់; ទទេ = ច្បាប់ផ្ទាល់របស់ប្រភេទឆ្នោត",
  "every product": "គ្រប់ប្រភេទឆ្នោត",
  // company creation (Phase 7)
  "A company goes live only when everything below that is required is done.": "ក្រុមហ៊ុនដំណើរការបានតែពេលអ្វីៗដែលចាំបាច់ខាងក្រោមបានធ្វើរួច។",
  "A new company starts in Testing. You make it Live from its page when it is ready.": "ក្រុមហ៊ុនថ្មីចាប់ផ្តើមក្នុងការសាកល្បង។ អ្នកធ្វើឱ្យវាដំណើរការពីទំព័ររបស់វា ពេលវារួចរាល់។",
  "A suspended company cannot sell. Its tickets, results and history stay.": "ក្រុមហ៊ុនដែលបានផ្អាកមិនអាចលក់បានទេ។ សំបុត្រ លទ្ធផល និងប្រវត្តិរបស់វានៅដដែល។",
  "Admin": "អ្នកគ្រប់គ្រង",
  "Back": "ថយក្រោយ",
  "Closing is final: the company cannot sell again. Its history stays.": "ការបិទគឺចុងក្រោយ៖ ក្រុមហ៊ុនមិនអាចលក់ម្តងទៀតបានទេ។ ប្រវត្តិរបស់វានៅដដែល។",
  "Company users": "អ្នកប្រើរបស់ក្រុមហ៊ុន",
  "Contact email": "អ៊ីមែលទំនាក់ទំនង",
  "Contact name": "ឈ្មោះអ្នកទំនាក់ទំនង",
  "Contact phone": "ទូរស័ព្ទទំនាក់ទំនង",
  "Copied": "បានចម្លង",
  "Copy": "ចម្លង",
  "Create one with New client.": "បង្កើតមួយដោយ អតិថិជនថ្មី។",
  "Create the company": "បង្កើតក្រុមហ៊ុន",
  "Created": "បានបង្កើត",
  "Display name": "ឈ្មោះបង្ហាញ",
  "Edit details": "កែព័ត៌មាន",
  "First password": "លេខសម្ងាត់ដំបូង",
  "Give it to the company’s admin privately. It is not stored readable anywhere; if it is lost, make a new one from the company’s page.": "ផ្តល់វាដល់អ្នកគ្រប់គ្រងក្រុមហ៊ុនដោយសម្ងាត់។ វាមិនត្រូវបានរក្សាទុកជាអក្សរអាចអានបាននៅកន្លែងណាទេ; បើបាត់ សូមបង្កើតថ្មីពីទំព័រក្រុមហ៊ុន។",
  "Last sign-in": "ចូលចុងក្រោយ",
  "Must change password": "ត្រូវប្តូរលេខសម្ងាត់",
  "New client": "អតិថិជនថ្មី",
  "New first password": "លេខសម្ងាត់ដំបូងថ្មី",
  "Next": "បន្ទាប់",
  "No template — start with nothing": "គ្មានគំរូ — ចាប់ផ្តើមទទេ",
  "No user yet.": "មិនទាន់មានអ្នកប្រើ។",
  "None — install products from the company’s page.": "គ្មាន — ដំឡើងប្រភេទឆ្នោតពីទំព័រក្រុមហ៊ុន។",
  "Notes": "កំណត់ចំណាំ",
  "Open the company": "បើកក្រុមហ៊ុន",
  "Products installed": "ប្រភេទឆ្នោតបានដំឡើង",
  "Products the company gets": "ប្រភេទឆ្នោតដែលក្រុមហ៊ុនទទួលបាន",
  "Reason": "មូលហេតុ",
  "Shown only now — give it to the user privately. The old password no longer works.": "បង្ហាញតែពេលនេះ — ផ្តល់ដល់អ្នកប្រើដោយសម្ងាត់។ លេខសម្ងាត់ចាស់លែងប្រើបានហើយ។",
  "Starter template": "គំរូចាប់ផ្តើម",
  "Steps": "ជំហាន",
  "The admin’s first password — shown only now": "លេខសម្ងាត់ដំបូងរបស់អ្នកគ្រប់គ្រង — បង្ហាញតែពេលនេះ",
  "The company is in Testing.": "ក្រុមហ៊ុននៅក្នុងការសាកល្បង។",
  "The company signs in to its own console once that console is built; staff and permissions come in Phase 9.": "ក្រុមហ៊ុនចូលផ្ទាំងគ្រប់គ្រងផ្ទាល់ខ្លួន ពេលផ្ទាំងនោះបានបង្កើតរួច; បុគ្គលិក និងសិទ្ធិមកដល់នៅដំណាក់កាលទី ៩។",
  "The company’s first admin. A first password is made and shown once after the company is created; the admin changes it at first sign-in.": "អ្នកគ្រប់គ្រងដំបូងរបស់ក្រុមហ៊ុន។ លេខសម្ងាត់ដំបូងត្រូវបានបង្កើត ហើយបង្ហាញម្តងគត់ក្រោយបង្កើតក្រុមហ៊ុន; អ្នកគ្រប់គ្រងប្តូរវាពេលចូលលើកដំបូង។",
  "This package and template do not fit together": "កញ្ចប់ និងគំរូនេះមិនត្រូវគ្នាទេ",
  "Type the client code to confirm": "វាយកូដអតិថិជន ដើម្បីបញ្ជាក់",
  "advice": "ដំបូន្មាន",
  "served from Phase 10": "ដំណើរការពីដំណាក់កាលទី ១០",
  "Package and template": "កញ្ចប់ និងគំរូ",
  "Check and create": "ពិនិត្យ និងបង្កើត",
  "Make live": "ធ្វើឱ្យដំណើរការ",
  "Suspend": "ផ្អាក",
  "Resume": "បន្តវិញ",
  "Back to testing": "ត្រឡប់ទៅសាកល្បង",
  "The client has a package": "អតិថិជនមានកញ្ចប់",
  "Nothing beyond its package": "គ្មានអ្វីលើសកញ្ចប់",
  "At least one product installed": "ដំឡើងប្រភេទឆ្នោតយ៉ាងតិចមួយ",
  "A company admin exists": "មានអ្នកគ្រប់គ្រងក្រុមហ៊ុន",
  "A test ticket was sold": "បានលក់សំបុត្រសាកល្បង",
  // hierarchy and commission (Phase 8)
  "Account": "គណនី",
  "Account under the company": "គណនីនៅក្រោមក្រុមហ៊ុន",
  "Accounts": "គណនី",
  "Add a rule": "បន្ថែមច្បាប់",
  "Add the level": "បន្ថែមកម្រិត",
  "Areas": "តំបន់",
  "Commission": "កម្រៃជើងសារ",
  "Commission %": "កម្រៃជើងសារ %",
  "Commission statement": "របាយការណ៍កម្រៃជើងសារ",
  "Create": "បង្កើត",
  "Deal": "កិច្ចព្រមព្រៀង",
  "Empty = every one. The most specific rule wins. Profit share: sell − winning − commission; winning share: only when there are winnings.": "ទទេ = ទាំងអស់។ ច្បាប់ជាក់លាក់បំផុតឈ្នះ។ ភាគហ៊ុនប្រាក់ចំណេញ៖ លក់ − សងឈ្នះ − កម្រៃជើងសារ; ភាគហ៊ុនសងឈ្នះ៖ តែពេលមានការសងឈ្នះ។",
  "From": "ពី",
  "Geography is separate from the hierarchy: one account may cover many areas.": "ភូមិសាស្ត្រដាច់ដោយឡែកពីឋានានុក្រម៖ គណនីមួយអាចគ្របដណ្តប់តំបន់ច្រើន។",
  "Hierarchy": "ឋានានុក្រម",
  "Hierarchy and commission": "ឋានានុក្រម និងកម្រៃជើងសារ",
  "Inside": "នៅក្នុង",
  "Level": "កម្រិត",
  "Levels": "កម្រិត",
  "Levels named by the company, accounts under them, their areas and what each account earns.": "កម្រិតដែលក្រុមហ៊ុនដាក់ឈ្មោះ គណនីនៅក្រោមវា តំបន់ និងអ្វីដែលគណនីនីមួយៗរកបាន។",
  "Make the company’s levels first (Levels).": "សូមបង្កើតកម្រិតរបស់ក្រុមហ៊ុនជាមុនសិន (កម្រិត)។",
  "May sit under": "អាចនៅក្រោម",
  "New account": "គណនីថ្មី",
  "No account (platform test)": "គ្មានគណនី (សាកល្បងវេទិកា)",
  "No account yet.": "មិនទាន់មានគណនី។",
  "None — the company makes its own levels.": "គ្មាន — ក្រុមហ៊ុនបង្កើតកម្រិតខ្លួនឯង។",
  "Sales": "ការលក់",
  "Sells": "លក់",
  "Share": "ភាគហ៊ុន",
  "Share %": "ភាគហ៊ុន %",
  "Share kind": "ប្រភេទភាគហ៊ុន",
  "Sold by": "លក់ដោយ",
  "The company": "ក្រុមហ៊ុន",
  "The company keeps": "ក្រុមហ៊ុនរក្សាទុក",
  "The parent has": "មេមាន",
  "Top area": "តំបន់កំពូល",
  "Under": "នៅក្រោម",
  "Under it": "នៅក្រោមវា",
  "Winnings": "សងឈ្នះ",
  "accounts": "គណនី",
  "all": "ទាំងអស់",
  "the company": "ក្រុមហ៊ុន",
  "tickets not settled yet — their winnings are not in": "សំបុត្រមិនទាន់ទូទាត់ — ការសងឈ្នះរបស់វាមិនទាន់រាប់បញ្ចូល",
  "under the company": "នៅក្រោមក្រុមហ៊ុន",
  "No share": "គ្មានភាគហ៊ុន",
  "Profit share": "ភាគហ៊ុនប្រាក់ចំណេញ",
  "Winning share": "ភាគហ៊ុនសងឈ្នះ",
  "Disable": "បិទ",
  "Enable": "បើក",
  "An account that sells exists": "មានគណនីដែលលក់",
  // company users, permissions, staff (Phase 9)
  "Company admin": "អ្នកគ្រប់គ្រងក្រុមហ៊ុន",
  "Company code": "កូដក្រុមហ៊ុន",
  "Every change in the company, with who made it and for which account.": "រាល់ការផ្លាស់ប្តូរក្នុងក្រុមហ៊ុន ជាមួយអ្នកធ្វើ និងសម្រាប់គណនីណា។",
  "Lowering a user lowers everyone it made, all the way down.": "ការបន្ថយសិទ្ធិអ្នកប្រើ បន្ថយអ្នកដែលខ្លួនបង្កើតទាំងអស់ រហូតដល់ក្រោមបង្អស់។",
  "New staff": "បុគ្គលិកថ្មី",
  "Operation Manager": "អ្នកគ្រប់គ្រងប្រតិបត្តិការ",
  "Permissions": "សិទ្ធិ",
  "Position": "តួនាទី",
  "Role": "តួនាទី",
  "Staff": "បុគ្គលិក",
  "What you may do": "អ្វីដែលអ្នកអាចធ្វើ",
  "Who may do what. Full edit, read only, or not allowed — nobody gives more than they have.": "អ្នកណាអាចធ្វើអ្វី។ កែបានពេញ អានតែប៉ុណ្ណោះ ឬមិនអនុញ្ញាត — គ្មាននរណាផ្តល់លើសពីអ្វីដែលខ្លួនមានទេ។",
  "Works for": "ធ្វើការឱ្យ",
  "You": "អ្នក",
  "Home": "ទំព័រដើម",
  "Accounts, levels and areas": "គណនី កម្រិត និងតំបន់",
  "Commission deals": "កិច្ចព្រមព្រៀងកម្រៃជើងសារ",
  "Tickets (sell, cancel)": "សំបុត្រ (លក់ លុបចោល)",
  "Company settings": "ការកំណត់ក្រុមហ៊ុន",
  "Staff and permissions": "បុគ្គលិក និងសិទ្ធិ",
  "Not allowed": "មិនអនុញ្ញាត",
  "Read only": "អានតែប៉ុណ្ណោះ",
  "Full edit": "កែបានពេញ",
  'The company signs in with its code on the sign-in page (Company) and manages its own staff there.': 'ក្រុមហ៊ុនចូលប្រើដោយកូដរបស់ខ្លួននៅទំព័រចូល (ក្រុមហ៊ុន) ហើយគ្រប់គ្រងបុគ្គលិករបស់ខ្លួននៅទីនោះ។',
  // domains and releases (Phase 10)
  "Activate": "ធ្វើឱ្យសកម្ម",
  "Add own domain": "បន្ថែមដែនផ្ទាល់ខ្លួន",
  "Add this DNS TXT record": "បន្ថែមកំណត់ត្រា DNS TXT នេះ",
  "App": "កម្មវិធី",
  "Build once, release to everyone, to some packages or to some companies. Devices ask whether they must update — nothing is sent to a client by hand.": "បង្កើតម្តង ចេញផ្សាយដល់គ្រប់គ្នា ដល់កញ្ចប់ខ្លះ ឬក្រុមហ៊ុនខ្លះ។ ឧបករណ៍សួរថាតើត្រូវធ្វើបច្ចុប្បន្នភាពឬអត់ — គ្មានអ្វីផ្ញើដល់អតិថិជនដោយដៃទេ។",
  "Check DNS": "ពិនិត្យ DNS",
  "Every company’s addresses. A company gets its automatic address when it is created; its own domain is proven by a DNS record, then activated here — no code change.": "អាសយដ្ឋានរបស់ក្រុមហ៊ុនទាំងអស់។ ក្រុមហ៊ុនទទួលបានអាសយដ្ឋានស្វ័យប្រវត្តិពេលបង្កើត; ដែនផ្ទាល់ខ្លួនត្រូវបានបញ្ជាក់ដោយកំណត់ត្រា DNS រួចធ្វើឱ្យសកម្មនៅទីនេះ — មិនចាំបាច់កែកូដ។",
  "Everyone": "គ្រប់គ្នា",
  "Link to the build (APK)": "តំណទៅកាន់កម្មវិធី (APK)",
  "Mandatory": "កាតព្វកិច្ច",
  "Mandatory — devices must update before they go on": "កាតព្វកិច្ច — ឧបករណ៍ត្រូវធ្វើបច្ចុប្បន្នភាពមុននឹងបន្ត",
  "Minimum": "អប្បបរមា",
  "New release": "ការចេញផ្សាយថ្មី",
  "No domain yet.": "មិនទាន់មានដែន។",
  "No release yet.": "មិនទាន់មានការចេញផ្សាយ។",
  "Notes (English)": "កំណត់ចំណាំ (អង់គ្លេស)",
  "Notes (Khmer)": "កំណត់ចំណាំ (ខ្មែរ)",
  "Own domain": "ដែនផ្ទាល់ខ្លួន",
  "Release": "ចេញផ្សាយ",
  "Serves": "បម្រើ",
  "The companies of these packages": "ក្រុមហ៊ុននៃកញ្ចប់ទាំងនេះ",
  "These companies": "ក្រុមហ៊ុនទាំងនេះ",
  "Who gets it": "អ្នកណាទទួលបាន",
  "Withdraw": "ដកចេញ",
  "companies": "ក្រុមហ៊ុន",
  "Management console": "ផ្ទាំងគ្រប់គ្រង",
  "Agent web app": "កម្មវិធីភ្នាក់ងារលើវេប",
  "Data entry": "បញ្ចូលទិន្នន័យ",
  "Agent app (Android)": "កម្មវិធីភ្នាក់ងារ (Android)",
  "Agent web app (PWA)": "កម្មវិធីភ្នាក់ងារលើវេប (PWA)",
  "Data entry (PWA)": "បញ្ចូលទិន្នន័យ (PWA)",
  "Proven": "បានបញ្ជាក់",
  "Waiting for DNS": "រង់ចាំ DNS",
  "Disabled": "បានបិទ",
  "Automatic address": "អាសយដ្ឋានស្វ័យប្រវត្តិ",
  "Released": "បានចេញផ្សាយ",
  "Withdrawn": "បានដកចេញ",
  // hardening and support (Phase 11)
  "Checks": "ការត្រួតពិនិត្យ",
  "Each value with where it comes from. Your own values override what your package and template give.": "តម្លៃនីមួយៗជាមួយប្រភពរបស់វា។ តម្លៃផ្ទាល់ខ្លួនរបស់អ្នកជំនួសអ្វីដែលកញ្ចប់ និងគំរូផ្តល់ឱ្យ។",
  "Only the company’s own values (overrides)": "តែតម្លៃផ្ទាល់ខ្លួនរបស់ក្រុមហ៊ុន (ការជំនួស)",
  "Overview": "ទិដ្ឋភាពទូទៅ",
  "The lottery products your company sells, each on its version.": "ប្រភេទឆ្នោតដែលក្រុមហ៊ុនរបស់អ្នកលក់ នីមួយៗនៅលើកំណែរបស់វា។",
  "Database and migrations": "មូលដ្ឋានទិន្នន័យ និងការធ្វើចំណាកស្រុក",
  "Results published on time": "លទ្ធផលបានផ្សាយទាន់ពេល",
  "Every ticket of a published draw is settled": "សំបុត្រនៃការចេញលទ្ធផលដែលបានផ្សាយ ត្រូវបានទូទាត់ទាំងអស់",
  "Own domains waiting for their DNS record": "ដែនផ្ទាល់ខ្លួនកំពុងរង់ចាំកំណត់ត្រា DNS",
  "Company users locked by wrong passwords": "អ្នកប្រើក្រុមហ៊ុនដែលជាប់សោដោយលេខសម្ងាត់ខុស",
  "Clients without problems": "អតិថិជនគ្មានបញ្ហា",
  // owner 2026-09-22: edit everything, prices, configuration gaps
  "Add a gap": "បន្ថែមចន្លោះខ្វះ",
  "Amount": "ចំនួនទឹកប្រាក់",
  "Can sign in": "អាចចូលប្រើបាន",
  "Configuration gaps": "ការកំណត់ដែលនៅខ្វះ",
  "Configuration gaps — waiting for their source": "ការកំណត់ដែលនៅខ្វះ — កំពុងរង់ចាំប្រភព",
  "Empty = the copy above": "ទទេ = ច្បាប់ចម្លងខាងលើ",
  "How often": "រយៈពេលបង់",
  "New pattern": "គំរូថ្មី",
  "No price": "គ្មានតម្លៃ",
  "No price yet": "មិនទាន់មានតម្លៃ",
  "Own pattern": "គំរូផ្ទាល់ខ្លួន",
  "Own price": "តម្លៃផ្ទាល់ខ្លួន",
  "Price": "តម្លៃ",
  "Result pattern": "គំរូលទ្ធផល",
  "Rule (JSON)": "ច្បាប់ (JSON)",
  "Same result as another draw": "លទ្ធផលដូចការចេញផ្សេងទៀត",
  "The automatic address moves to the new name.": "អាសយដ្ឋានស្វ័យប្រវត្តិនឹងប្តូរទៅឈ្មោះថ្មី។",
  "The game’s pattern": "គំរូរបស់ហ្គេម",
  "Use the package’s price": "ប្រើតម្លៃរបស់កញ្ចប់",
  "What is missing": "អ្វីដែលនៅខ្វះ",
  "What is not confirmed yet. Never guess a result rule: write the gap here until the source is given.": "អ្វីដែលមិនទាន់បញ្ជាក់។ កុំទាយច្បាប់លទ្ធផល៖ សរសេរចន្លោះខ្វះនៅទីនេះ រហូតដល់មានប្រភព។",
  "every draw": "គ្រប់ការចេញ",
  "source": "ប្រភព",
  "a month": "ក្នុងមួយខែ",
  "a year": "ក្នុងមួយឆ្នាំ",
  "once": "តែម្តង",
  "The package’s price": "តម្លៃរបស់កញ្ចប់",
  "A pattern from the engine is not edited — make a copy.": "គំរូពីម៉ាស៊ីនមិនអាចកែបានទេ — សូមចម្លងវា។",
  "A published product uses this pattern — make a copy and use the copy in a new version.": "ផលិតផលដែលបានផ្សាយប្រើគំរូនេះ — សូមចម្លង ហើយប្រើច្បាប់ចម្លងក្នុងកំណែថ្មី។",
};
